<template>
  <b-container fluid>
    <b-form @submit="authenticate">
      <b-row class="my-1">
        <b-col sm="3" lg="3"></b-col>
        <b-col sm="6" lg="6">
          <img :title="$t('LNG_TITLE', this.lang)" :alt="$t('LNG_TITLE', this.lang)" width="200px" src="../assets/img/logo.jpg">
          <h2>{{ $t('LNG_WELCOME', lang) }}</h2>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3" lg="4"></b-col>
        <b-col md="6" lg="4">
           <b-input-group>       
              <b-input-group-text slot="prepend">
                 <i class="fa fa-fw fa-user"></i>
              </b-input-group-text>
              <b-form-input type="email" @keydown="setErrorMessage('')" class="form-control" v-model="username" :placeholder="$t('LNG_EMAIL', lang)" required autofocus autocapitalize="off"></b-form-input>
           </b-input-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3" lg="4"></b-col>
        <b-col sm="6" lg="4">
           <b-input-group>       
              <b-input-group-text slot="prepend">
                 <i class="fa fa-fw fa-at"></i>
              </b-input-group-text>
              <b-form-input type="password" @keydown="setErrorMessage('')" class="form-control" v-model="password" :placeholder="$t('LNG_PASSWORD', lang)" required autofocus autocapitalize="off"></b-form-input>
           </b-input-group>
        </b-col>
      </b-row>
      <b-row class="my-3">  
        <b-col sm="3" lg="4"></b-col>
        <b-col sm="6" lg="4">
           <b-button variant="evaobj" type="submit">{{ $t('LNG_LOGIN_BTN', lang) }}</b-button>
        </b-col>
      </b-row>
      <b-row class="my-3">  
        <b-col sm="3" lg="4"></b-col>
        <b-col sm="6" lg="4">
           <b-button type="submit" variant="link" v-on:click.prevent="recoverPassword()">{{ $t('LNG_RECOVER_PASSWORD', lang) }}</b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-row class="my-1" v-if="errorMessage !== ''">
      <b-col sm="3" lg="4"></b-col>
      <b-col sm="6" lg="4">
         <b-alert variant="danger" show>{{ this.errorMessage }}</b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { focus } from 'vue-focus'
export default {
  name: 'login',
  data () {
    return {
      code: '',
      counter: 0,
      errorMessage: '',
      focus: '',
      password: '',
      successMessage: '',
      username: ''
    }
  },
  ready: function () {
    this.focus = ((this.username !== '') ? 'username' : 'password')
  },
  directives: {
    focus: focus
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    ...mapState([
      'api',
      'fullname',
      'lang'
    ])
  },
  methods: {
    setErrorMessage (errorTag = '') {
      this.errorMessage = errorTag
    },
    recoverPassword: function () {
      this.$router.push({ path: '/recoverPassword' })
    },
    setSuccessMessage (successMessage = '') {
      this.successMessage = successMessage
    },
    authenticate: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'checkLogin',
          username: this.username,
          password: this.password
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.password = ''
        if (response.data.authenticated) {
          var authObj = {
            changePassword: response.data.changePassword,
            fullname: this.username,
            token: true,
            adminLevel: response.data.adminLevel,
            licence: response.data.licence
          }
          this.$store.commit('AUTHENTICATE', authObj)
          this.$router.push({ path: '/mainview' })
        } else {
          this.focus = 'username'
          this.setErrorMessage(this.$t('LNG_LOGIN_FAILED', this.lang))
        }
      })
      .catch(function (error) {
        this.password = ''
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.login {
  margin-top: 50px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Login.vue?62475352